import React from 'react';

const EditProductivity =  ({ productivitys, onChange, onSubmit }) => {
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      margin: '20px'
    }}>
      <h1 style={{
    
        marginBottom: '20px'
      }}>Productivity</h1>
      <div style={{ border: "1px solid #f8f9fa",
                  borderTop: "3px solid #004aad",
                  backgroundColor: "#e9ecef",
                  padding:"20px"}}>
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        marginTop: '20px',
        border: '1px solid #ddd'
      }}>
        <thead>
          <tr>
            <th style={{
              border: '1px solid #ddd',
              padding: '8px',
              textAlign: 'left',
              backgroundColor: '#f2f2f2'
            }}>Departments</th>
            <th colSpan="2" style={{
              border: '1px solid #ddd',
              padding: '8px',
              textAlign: 'left',
              backgroundColor: '#f2f2f2'
            }}>Users</th>
          </tr>
          <tr>
            <th style={{
              border: '1px solid #ddd',
              padding: '8px',
              textAlign: 'left',
              backgroundColor: '#f2f2f2'
            }}></th>
            <th style={{
              border: '1px solid #ddd',
              padding: '8px',
              textAlign: 'left',
              backgroundColor: '#f2f2f2'
            }}>Hira KH</th>
            <th style={{
              border: '1px solid #ddd',
              padding: '8px',
              textAlign: 'left',
              backgroundColor: '#f2f2f2'
            }}></th>
          </tr>
        </thead>
        <tbody>
          {[
            'All Departments',
            'CROWN AND BRIDGE',
            'PROSTHETICS',
            'ORTHODONTIC',
            'IMPLANTS',
            'COBALT CHROME',
            'VALPLAST',
            'PLASTER ROOM',
            'ALL DEPARTMENTS',
            'No Department'
          ].map((department, index) => (
            <tr key={index} style={{
              backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9'
            }}>
              <td style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'left'
              }}>{department}</td>
              <td style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'left'
              }}>Scan</td>
              <td style={{
                border: '1px solid #ddd',
                padding: '8px',
                textAlign: 'left'
              }}>Be Assigned</td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default EditProductivity;